import { normalizeApiError } from '../api/apiError';
import { createReadAsyncThunk } from "../store/createReadAsyncThunk";
import { createSlice } from "@reduxjs/toolkit";
import { Calendar } from '../../features/pcsCalendarOfActivities/api/calendarApi';
import { ApiRequestStatus } from "../enums/apiRequestStatus";
import { PcsEventInstanceDto } from "../models/events/pcsEventInstanceDto";
import { PcsCalendarOfActivitiesInstanceDto } from "../models/calendar/pcsCalendarOfActivitiesInstanceDto";

interface PcsCalendarState {
    calendarEventInstances: PcsEventInstanceDto[] | null;
    calendarOfActivitiesInstance: PcsCalendarOfActivitiesInstanceDto | null;

    calendarEventInstancesStatus: ApiRequestStatus;
    calendarOfActivitiesInstanceStatus: ApiRequestStatus;
}

const initialState: PcsCalendarState = {
    calendarEventInstances: null,
    calendarOfActivitiesInstance: null,

    calendarEventInstancesStatus: ApiRequestStatus.Idle,
    calendarOfActivitiesInstanceStatus: ApiRequestStatus.Idle
}

export const getCalendarEventInstancesAsync = createReadAsyncThunk<PcsEventInstanceDto[]>(
    'calendarSlice/getCalendarEventInstancesAsync',
    async (_, thunkAPI) => {
        try {
            return await Calendar.getCalendarEventInstancesAsync();
        } catch (error: unknown) {
            return thunkAPI.rejectWithValue(normalizeApiError(error));
        }
    }
)

export const getCalendarEventInstanceByIdAsync = createReadAsyncThunk<PcsCalendarOfActivitiesInstanceDto, string>(
    'calendarSlice/getCalendarEventInstanceByIdAsync',
    async (instanceId, thunkAPI) => {
        try {
            return await Calendar.getCalendarEventInstanceByIdAsync(instanceId);
        } catch (error: unknown) {
            return thunkAPI.rejectWithValue(normalizeApiError(error));
        }
    }
)

export const calendarSlice = createSlice({
    name: 'calendarSlice',
    initialState,
    reducers: {

    },
    extraReducers: (builder => {
        builder.addCase(getCalendarEventInstancesAsync.pending, (state) => {
            state.calendarEventInstancesStatus = ApiRequestStatus.Pending;
        });
        builder.addCase(getCalendarEventInstancesAsync.fulfilled, (state, action) => {
            state.calendarEventInstances = action.payload;
            state.calendarEventInstancesStatus = ApiRequestStatus.Fulfilled;
        });
        builder.addCase(getCalendarEventInstancesAsync.rejected, (state) => {
            state.calendarEventInstancesStatus = ApiRequestStatus.Rejected;
        });

        builder.addCase(getCalendarEventInstanceByIdAsync.pending, (state) => {
            state.calendarOfActivitiesInstanceStatus = ApiRequestStatus.Pending;
        });
        builder.addCase(getCalendarEventInstanceByIdAsync.fulfilled, (state, action) => {
            state.calendarOfActivitiesInstance = action.payload;
            state.calendarOfActivitiesInstanceStatus = ApiRequestStatus.Fulfilled;
        });
        builder.addCase(getCalendarEventInstanceByIdAsync.rejected, (state) => {
            state.calendarOfActivitiesInstanceStatus = ApiRequestStatus.Rejected;
        });
    })
})
